exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-text[data-v-fe6128c8] {\n  color: red;\n  display: block;\n}\n.c-text-link[data-v-fe6128c8] {\n  color: #0b57d0;\n  cursor: pointer;\n  text-decoration: none;\n}\n.c-text-link[data-v-fe6128c8]:hover {\n  color: blue;\n  text-decoration: underline;\n}\n.b-0[data-v-fe6128c8] {\n  border: none !important;\n  margin-bottom: 0 !important;\n}\n@media screen and (min-width: 896px) {\n.form-group[data-v-fe6128c8] {\n    padding: 0;\n}\n.form-control[data-v-fe6128c8] {\n    font-size: 16px;\n}\n}\n", ""]);

// exports
